import {call, put} from "redux-saga/effects";
import {receiveServiceLevelData} from "../actions/serviceLevelDataActions";
import {fetchServiceLevelData} from "../api/serviceLevelDataApi";

// worker Saga: will be fired on USER_FETCH_REQUESTED actions
export default function* getServiceLevelData(action) {
  try {
    // do api call
    const data = yield call(fetchServiceLevelData);
    yield put(receiveServiceLevelData(data));
  } catch (e) {
    console.log(e);
  }
}



// WEBPACK FOOTER //
// ./src/sagas/serviceLevelSaga.js